export default __webpack_public_path__ + "28807730a3ce86ba2910161be8379d28.svg";